<template>
	<div>
		<layout :mastheadBackgroundImage="mastheadBg">
			<div slot="masthead" class="center">
				<masthead>
					<template slot="headline">Subscribe to our mailing list</template>
					<template slot="content">Sign up to get our SyncUp Newsletter and any other pertinent StudySync news.</template>
				</masthead>
			</div>
			<div class="content" slot="body">
				<FormLayout>
					<div class="content__info" slot="info">
						<ul class="secondary-info">
							<li>
								<h4>StudySync</h4>
								<p>E: <a href="mailto:info@studysync.com">info@studysync.com</a></p>
							</li>
						</ul>
					</div>
					<div class="layout__form" slot="form">
						<SubscribeForm />
					</div>
				</FormLayout>
			</div>
		</layout>
	</div>
</template>

<script>

	import Layout from '@/layouts/layoutA'
	import Masthead from '@/layouts/layoutA/masthead'
	import FormLayout from '@/layouts/FormLayout'
	import SubscribeForm from '@/components/SubscribeForm'

	export default {
		metaInfo () {
			return this.$generateMetaInfo({
				title: `StudySync Newsletter Subscribe`,
				description: `Sign up to get our SyncUp Newsletter and any other pertinent StudySync news.`,
				image: 'https://www.studysync.com/static/img/subscribe1.d7404a9.jpg'
			})
		},
		data () {
			return {
				mastheadBg: require('img/mastheads/subscribe1.jpg')
			}
		},
		components: { Layout, Masthead, FormLayout, SubscribeForm }
	}
</script>

<style lang="scss" scoped>

	@import "responsive-font";
	@import "list-style-reset";
	@import "media";

	.content {
		@include responsive-font(10);
		@include media(small,xlarge) {
			background:#F6F8F9; padding-bottom:3em;
			& > * {
				padding-top:3em;
			}
		}
		@include media(xlarge) {
			& > * {
				background:#F6F8F9;
			}
		}

		.secondary-info {
			@include list-style-reset;
			@include responsive-font(18);
			color:#6D6E71;
			li + li {
				margin-top:2em;
			}
			h4 {
				@include responsive-font(12);
				font-family:'proxima-nova'; font-weight:600; letter-spacing:.075em; text-transform:uppercase; color:#FDB913;
			}
			p {
				margin:.25em 0 0;
			}
			a {
				color:inherit;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/routes/subscribe/index.vue